import React from "react";
import Navbar from "../components/Navbar/Navbar";
import Footer from "../components/Footer/Footer";
import { PageRenderer } from "../components/common/PageRenderer";
import styles from "./StaticPage.module.css";

export default function PrivacyPage() {
  return (
    <>
      <Navbar />
      <main className={styles.main}>
        <div className="container">
          <h1 className={styles.title}>Privacy Policy</h1>
          <PageRenderer pageKey="privacyPolicy" />
        </div>
      </main>
      <Footer />
    </>
  );
}
